import React from "react";

import { formatNumber, formatNumericCurrency, getAdminVerificationYearlyDataYear } from "utils";

export const PayoutExtraInfo = ({ farmIsVerified, preVerificationCredits, preVerificationPayout, credits, payout }) => {
  const showDeclined = preVerificationCredits != null;

  return (
    <div className="payout-extra-info grey-super-light-bg">
      <div className="payout-row">
        <div>total carbon credits</div>
        <div className="verification-totals">
          {showDeclined && <div className="rejected-total margin-right-50">{formatNumber({ number: preVerificationCredits, decimalPlaces: 2 })}</div>}
          <div className={`${!farmIsVerified ? "farm-rejected" : "approved-total"}`}>
            {credits != null ? formatNumber({ number: credits, decimalPlaces: 2 }) : ""}
          </div>
        </div>
      </div>
      <div className="payout-row">
        <div>total {getAdminVerificationYearlyDataYear()} payout</div>
        <div className="verification-totals">
          {showDeclined && <div className="rejected-total margin-right-50">{formatNumericCurrency(preVerificationPayout)}</div>}
          <div className={`${!farmIsVerified ? "farm-rejected" : "approved-total"}`}>{payout != null ? formatNumericCurrency(payout) : ""}</div>
        </div>
      </div>
    </div>
  );
};
